"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _alert = _interopRequireDefault(require("./alert"));

var _confirm = _interopRequireDefault(require("./confirm"));

var _prompt = _interopRequireDefault(require("./prompt"));

/**
 * 用于队列 interaction 请求
 */
var InteractionManager =
/*#__PURE__*/
function () {
  function InteractionManager() {
    (0, _classCallCheck2.default)(this, InteractionManager);
    (0, _defineProperty2.default)(this, "$tail", null);
    (0, _defineProperty2.default)(this, "$interactionMap", {
      alert: _alert.default,
      confirm: _confirm.default,
      prompt: _prompt.default
    });
  }

  (0, _createClass2.default)(InteractionManager, [{
    key: "getInteractionMethod",
    value: function getInteractionMethod(method) {
      return this.$interactionMap[method];
    }
  }, {
    key: "interactionMethodExists",
    value: function interactionMethodExists(method) {
      return !!this.$interactionMap[method];
    }
  }, {
    key: "requestInteraction",
    value: function requestInteraction(method) {
      var _this = this;

      if (!this.interactionMethodExists(method)) {
        return Promise.reject(new Error("No such interaction '".concat(method, "' found.")));
      }

      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      var newTail = this.$tail ? this.queueInteraction.apply(this, [this.$tail, method].concat(args)) : this.performInteraction.apply(this, [method].concat(args));
      newTail.finally(function () {
        if (_this.$tail === newTail) {
          _this.$tail = null;
        }
      });
      this.$tail = newTail;
      return this.$tail;
    }
  }, {
    key: "queueInteraction",
    value: function queueInteraction(tail, method) {
      var _this2 = this;

      for (var _len2 = arguments.length, args = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      return new Promise(function (resolve, reject) {
        tail.finally(function () {
          _this2.performInteraction.apply(_this2, [method].concat(args)).then(resolve, reject);
        });
      });
    }
  }, {
    key: "performInteraction",
    value: function performInteraction(method) {
      for (var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
        args[_key3 - 1] = arguments[_key3];
      }

      return this.getInteractionMethod(method).apply(void 0, args);
    }
  }, {
    key: "resetQueue",
    value: function resetQueue() {
      this.$tail = null;
    }
  }]);
  return InteractionManager;
}();

var _default = new InteractionManager();

exports.default = _default;